import {React} from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import './App.css';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';



function App() {
  return (
    <>
      <Header/>
        <RouterProvider router={router}/>
      <Footer/>
    </>
  );
}

export default App;
